<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            :rounded="rounded"
            :standout="standout"
            :flat="flat"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            :use-input="false"
            @input="$emit('input', $event)"
            :loading="$apollo.queries.projects.loading"
        >

            <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents" class="project-filters_item__wrapper">
                    <q-item-section class="project-filters_item">
                        <q-item-label>
                            {{ scope.opt.label }}
                        </q-item-label>
                        <q-item-label caption class="u-text-truncate-2lines">{{ scope.opt.description }}</q-item-label>
                        <q-item-label caption class="ml-auto"><span v-if="scope.opt.start_date != scope.opt.end_date">du </span>{{ scope.opt.start_date }}<span v-if="scope.opt.start_date != scope.opt.end_date"> au {{ scope.opt.end_date }}</span> </q-item-label>
                    </q-item-section>
                    <q-item-section side top class="project-filters_item">
                        <ProjectCardToggle class="q-mr-xs" style="float: right;" :projectID="scope.opt.id" :size="'16px'" />
                    </q-item-section>
                </q-item>
            </template>

            <template v-slot:selected
                v-if="showMax && multiple && $attrs && $attrs.value && $attrs.value.length>parseInt(showMax)"
            >
                <span>{{ $attrs.value.length }} éléments sélectionnés</span>
            </template>
            <template v-slot:no-option
            >
                <div>
                    <q-item>
                        <Input
                            v-model="searchText"
                            :dark="$attrs.dark"
                            placeholder="Filtrer"
                            class="full-width c-select-filter-input"
                            autofocus
                            :filled="false"
                            dense
                            flat
                            borderless
                        />
                    </q-item>
                </div>
                <div>
                    <q-item v-if="$apollo.queries.projects.loading">
                        S.V.P. Patientez...
                    </q-item>
                    <q-item v-else>
                        Aucun projet trouvé
                    </q-item>
                </div>
            </template>
            <template v-slot:before-options
            >
                <div>
                    <q-item-section class="project-filters_params">
                        <q-item>
                            <Input
                                v-model="searchText"
                                :dark="$attrs.dark"
                                placeholder="Rechercher un projet"
                                class="full-width c-select-filter-input"
                                autofocus
                                :filled="false"
                                dense
                                flat
                                borderless
                            />
                        </q-item>
                        <q-item-section class="project-assignments-filters">
                            <div class="q-px-md q-pt-none q-pb-md">
                                <div class="q-gutter-sm">
                                    <q-radio size="xs" dense v-model="assignmentType" dark val="assignments" label="Affectations publiées" />
                                    <q-radio class="q-ml-md" size="xs" dense v-model="assignmentType" dark val="draftAssignments" label="Affectations planifiées" />
                                </div>
                            </div>
                        </q-item-section>
                    </q-item-section>
                </div>
            </template>
        </q-select>
        <!-- <q-select
            v-bind="$attrs"
            :outlined="outlined"
            :rounded="rounded"
            :standout="standout"
            :flat="flat"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            use-input
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:selected
                v-if="showMax && multiple && $attrs && $attrs.value && $attrs.value.length>parseInt(showMax)"
            >
                <span>{{ $attrs.value.length }} éléments sélectionnés</span>
            </template>
        </q-select> -->
    </div>
</template>

<script>
    import { PROJECTSSEARCH/*, TAGSSEARCH*/ } from '@/graphql/search/queries'
    import QSelect from 'quasar'
    // import uniqBy from 'lodash/uniqBy'

    export default {
        name: 'ProjectInput',
        extends: QSelect,
        data(){
            return{
                searchTO: {},
                searchText: '',
                projectsFiltered: [],
                assignmentType: 'assignments'
            }
        },
        props: {
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            rounded: {
                type: Boolean,
                default: false
            },
            standout: {
                type: Boolean,
                default: false
            },
            flat: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            showMax: {
                type: [Boolean, Number, String],
                default: false
            },
            userGroups: {
                type: Array,
                default: null
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            },
        },
        // mounted(){
        // },
        computed: {
            menuItems() {
                let data = [];
                if (this.$apollo.queries.projects && !this.$apollo.queries.projects.loading) {
                    data = this.projectsFiltered.map(item => {
                        return {
                            label: item.name,
                            value: item.id,
                            ...item
                        }
                    })
                }
                return data;
            }
        },
        watch: {

            assignmentType: function () {
                this.$emit('set-assignments-tyoe', this.assignmentType)
            },

            searchText: function(){
                // if(this.searchText.trim()==""){
                //     this.projectsFiltered=this.projects
                // }else{
                //     let projects=this.projects;
                //     projects = projects.filter(item => item.name.toLowerCase().search(this.searchText.toLowerCase())!==-1);
                //     this.projectsFiltered=projects
                // }
            }
    },
        methods: {
        },
        apollo: {
            projects: {
                query: PROJECTSSEARCH,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    return {
                        searchText: this.searchText,
                        orderBy: 'updated_at',
                    }
                },
                debounce: 700,
                update(data) {

                    this.projectsFiltered = data.projectsSearch.data

                    setTimeout(function () {
                        this.$refs.myInput.refresh();
                    }.bind(this), 100)

                    return data.projects


                },
            }
        }
    }

</script>

<style lang="scss" scoped>

    .project-filters_item__wrapper {
        max-width: 400px;
        min-width: 400px;
        padding: 0 12px;

        &:hover {
            background: $color-1;
        }
    }

    .project-filters_item {
        border-bottom: 1px dotted $color-1;
        padding: 12px 0;
    }

    .userProfiles {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }

    .project-filters_params {
        background: $color-1-darker;
    }
    .project-assignments-filters {
        font-size: 0.85rem;
        border-bottom: 1px solid $color-1;
        padding-top: 0;
    }
</style>